import { render, staticRenderFns } from "./inspectionTasksDetailModal.vue?vue&type=template&id=52406740&scoped=true"
import script from "./inspectionTasksDetailModal.vue?vue&type=script&lang=js"
export * from "./inspectionTasksDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52406740",
  null
  
)

export default component.exports